import { Stepper, Step, StepLabel, StepConnector } from "@mui/material";
import ButtonIconH from "./ButtonIconH";
import { styled } from "@mui/material";

export function DeliveryNoteStepHandler({
  step,
  onNextStep,
  onPreviousStep,
  disabled,
}) {
  const steps = [
    "Características de producto",
    "Datos de compra",
    "Distribución de stock",
    "Datos de venta",
    "Validación",
    "Codificación",
  ];

  const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`& .MuiStepConnector-line`]: {
      borderColor: "#afafaf",
    },
    [`&.Mui-completed .MuiStepConnector-line`]: {
      borderColor: "#069dde",
    },
    [`&.Mui-active .MuiStepConnector-line`]: {
      borderColor: "#ff9432",
    },
  }));

  return (
    <>
      <Stepper activeStep={step} connector={<CustomConnector />}>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel
              sx={{
                "& .MuiStepLabel-label": {
                  color: "#afafaf!important",
                  fontFamily: "Montserrat",
                  fontWeight: "500!important",
                },
                "& .MuiStepIcon-root": {
                  color: "#afafaf!important",
                  fontWeight: "500!important",
                },
                "& .Mui-active": {
                  color: "#ff9432!important",
                  fontWeight: "500!important",
                },
                "& .Mui-completed": {
                  color: "#069dde!important",
                  fontWeight: "500!important",
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px 0",
          gap: 20,
        }}
      >
        <ButtonIconH
          text="Anterior"
          small={true}
          disabled={disabled || step === 0}
          onClick={onPreviousStep}
        ></ButtonIconH>
        <ButtonIconH
          text="Siguiente"
          small={true}
          disabled={disabled || step === steps.length - 1}
          onClick={onNextStep}
        ></ButtonIconH>
      </div>
    </>
  );
}
